import { memo } from "react";
import InfoBlock from "../InfoBlock";
import { MdDevices } from "react-icons/md";

const SettingsPerDeviceInfoBlock: React.FC = () => {
  return (
    <InfoBlock
      title="Configuración local"
      message="Estas preferencias se guardan en tu navegador y solo se aplican en este dispositivo."
      displayMobileIcon
      icon={<MdDevices />}
    />
  );
};

export default memo(SettingsPerDeviceInfoBlock);
